module.exports = __webpack_public_path__ + "img/248.ec630a1c.png";